
import { formatDate } from "@/javascript/formatDate";
import { Dialog } from "vant";
import Panel from 'vux/src/components/panel/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import bus from "@/javascript/bus";
import util from "@/javascript/util";
import goBack from "@/components/public-components/goBack/index.vue";
import { Notify } from 'vant';

export default {
components: {
Panel,
Toast,
goBack,
},
data() {
return {
minHeight: 0,
userInfo: JSON.parse(localStorage.getItem("userInfo")),
historys: {},
toast: {
text: "",
show: false,
},
infiniteStatus: false,
infiniteAll: false,
historyListPageNo: 0,
historyListPageSize: 10,
};
},
mounted() {
document.title = "浏览记录";

this.minHeight = document.documentElement.clientHeight;
window.addEventListener("scroll", this.windowScroll);
this.getHistoryList();
},
methods: {
windowScroll: function () {
if (util.pullUpLoad()) {
this.infinite();
}
const scrollTop =
window.pageYOffset ||
document.documentElement.scrollTop ||
document.body.scrollTop;
if (!this.$refs.stickyBox) {
return;
}
if (scrollTop >= this.$refs.stickyBox.offsetTop) {
this.districtSticky = true;
this.handleMinHeight =
document.documentElement.clientHeight -
this.$refs.stickyBox.offsetTop +
this.$refs.stickyBox.offsetTop;
if (document.documentElement.clientWidth > 640) {
this.handleRight = (document.documentElement.clientWidth - 640) / 2;
}
} else {
this.districtSticky = false;
this.handleMinHeight =
document.documentElement.clientHeight -
this.$refs.stickyBox.offsetTop +
scrollTop;
this.handleRight = 0;
}
},
getHistoryList() {
this.$http
.get(
"/api/wtcp-member/public/history/page?page=" +
this.historyListPageNo +
"&size=" +
this.historyListPageSize +
"&userId=" +
this.userInfo.user.id +
"&access_token=" +
this.userInfo.access_token +
"&deptCode=" +
this.DEPT_CODE.DEPTCODE
)
.then((response) => {
const resData = response.data.data.content;
resData.forEach((item) => {
let desc = "";
switch (item.catalog) {
case 1:
desc = "攻略";
break;
case 2:
desc = "游记";
break;
case 3:
desc = "目的地";
break;
case 4:
desc = "景区";
break;
case 5:
desc = "旅行社";
break;
case 6:
desc = "农家乐";
break;
case 7:
desc = "租车";
break;
case 8:
desc = "自驾营地";
break;
case 9:
desc = "旅游示范村";
break;
case 10:
desc = "餐饮";
break;
case 11:
desc = "特产";
break;
case 12:
desc = "美食";
break;
case 13:
desc = "资讯";
break;
}
const date = formatDate(item.updatedDate, "MM月dd日"),
picUrl = item.catalog === 3 ? this.STATIC_BASE_URL : this.PIC_BASE_URL;
if (!this.historys.hasOwnProperty(date)) {
this.$set(this.historys, date, []);
}
if (item.catalog === 1 || item.catalog === 13) {
this.historys[date].push({
src: item.picUrl.includes('http') ? item.picUrl : this.PIC_BASE_URL + item.picUrl,
url: item.url.replace('/#', ''),
title: item.title,
desc: desc,
});
} else {
this.historys[date].push({
src: item.picUrl.includes('http') ? item.picUrl : picUrl + item.picUrl,
url: item.url.replace('/#', ''),
title: item.title,
desc: desc,
});
}
});
if (resData.length < this.historyListPageSize) {
this.infiniteAll = true;
}
this.infiniteStatus = false;
});
},
clearHistory() {
if (Object.keys(this.historys).length < 1) {
Notify('没有要删除的内容')
return
}
Dialog.confirm({
title: "提示",
message: "确定要删除历史记录吗?",
})
.then(() => {
this.$http
.delete(
"/api/wtcp-member/public/history/deleteAllHistoryByUser?userId=" +
this.userInfo.user.id +
"&deptCode=" +
this.DEPT_CODE.DEPTCODE +
"&access_token=" +
this.userInfo.access_token
)
.then((response) => {
if (response.data.status === 1) {
this.toast.text = response.data.msg;
this.toast.show = true;
this.$set(this, "historys", {});
}
});
})
.catch(() => {

});
},
infinite: function () {
if (this.infiniteAll) {
return;
}
if (this.infiniteStatus) {
return;
}

this.infiniteStatus = true;
this.historyListPageNo += this.historyListPageSize;
this.getHistoryList();
},
},
};
